import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { t } from '../../services/i18nService';
import modalStyles from '../../styles/generic/modal.scss';
import storeManager from '../../store/StoreManager';
import responseActions from '../../actions/ResponseActions';
import DefaultModal from './DefaultModal';

const OneWayNavigationOfflineModal = (props) => {
    const {
        showModal,
    } = props;

    const returnToQuestion = () => {
        storeManager.dispatch(responseActions.setOneWayNavigationOfflineCommitAttempt(false));
    };

    return (<DefaultModal
        isOpen={showModal}
        shouldCloseOnEsc
        shouldCloseOnOverlayClick
        onRequestClose={returnToQuestion}
    >
        <div className={modalStyles.modalContentWrapper} id="ownOfflineModalContent">
            <div className={modalStyles.modalTitle}>
                { t('navigation.oneWay.offlineMode.title') }
            </div>

            <div className={modalStyles.modalContent}>
                <div className={modalStyles.modalContentPart}>
                    <p>
                        { t('navigation.oneWay.offlineMode.descriptionOne') }
                    </p>
                    <p>
                        { t('navigation.oneWay.offlineMode.descriptionTwo') }
                    </p>
                </div>
            </div>

            <div className={modalStyles.modalFooterButtons}>
                <button className={`btn default-btn ${modalStyles.modalMainBtn}`} onClick={returnToQuestion}>
                    { t('navigation.oneWay.offlineMode.returnButton') }
                </button>
            </div>
        </div>
    </DefaultModal>);
};

OneWayNavigationOfflineModal.propTypes = {
    showModal: PropTypes.bool.isRequired,
};

const mapStateToProps = (state) => {
    return {
        showModal: !!state.response.isOfflineCommitAttempting,
    };
};

export default connect(mapStateToProps)(OneWayNavigationOfflineModal);
